/* Using a self-executing anonymous function - (function(){})(); - so that all variables and functions defined within 
aren’t available to the outside world. */

(function () {
  var loadScript = function (url, callback) {
    var script = document.createElement("script");
    script.type = "text/javascript";

    // If the browser is Internet Explorer.
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (script.readyState == "loaded" || script.readyState == "complete") {
          script.onreadystatechange = null;
          callback();
        }
      };
      // For any other browser.
    } else {
      script.onload = function () {
        callback();
      };
    }
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
    const style = document.createElement("style");
  };

  /* This is Timesact main function. */
  timesactScript = async function ($) {
    const style = document.createElement("style");
    style.id = "TimesactCSS";
    style.innerHTML = `.timesact-badge {
                          position: relative;
                        }
                        .timesact-badge-ribbon {
                          position: absolute;
                          right: -5px; top: -5px;
                          z-index: 1;
                          overflow: hidden;
                          width: 75px; height: 75px;
                          text-align: right;
                        }
                        .timesact-badge-ribbon span {
                          font-size: 10px;
                          font-weight: bold;
                          color: #FFF;
                          text-transform: uppercase;
                          text-align: center;
                          line-height: 20px;
                          transform: rotate(45deg);
                          -webkit-transform: rotate(45deg);
                          width: 100px;
                          display: block;
                          position: absolute;
                          top: 19px; right: -21px;
                        }
                        .timesact-badge-ribbon span::before {
                          content: "";
                          position: absolute; left: 0px; top: 100%;
                          z-index: -1;
                          border-left: 3px solid #888888;
                          border-right: 3px solid transparent;
                          border-bottom: 3px solid transparent;
                          border-top: 3px solid #888888;
                        }
                        .timesact-badge-ribbon span::after {
                          content: "";
                          position: absolute; right: 0px; top: 100%;
                          z-index: -1;
                          border-left: 3px solid transparent;
                          border-right: 3px solid #888888;
                          border-bottom: 3px solid transparent;
                          border-top: 3px solid #888888;
                        }`
    document.getElementsByTagName("head")[0].appendChild(style);
    /* Models */
    class Product {
      constructor(id, variants) {
        this.id = id;
        this.variants = variants;
      }

      setCurrentVariant(variantId) {
        this.variantId = variantId;
      }

      setPreorderVariants(productConfig) {
        if (!productConfig || !productConfig.variants) {
          console.log('[ERROR 2002]: Product config is undefined.')
          return;
        }
        this.preorderVariants = productConfig.variants;
      }

      isPreorderEnabledForVariant() {
        if (!this.preorderVariants[this.variantId] || !this.preorderVariants[this.variantId].config) {
          return false;
        }
        return this.preorderVariants[this.variantId].config.status === "ACTIVE" || this.preorderVariants[this.variantId].config.status === "NO_STOCK";
      }

      getVariantSettings(globalSettings) {
        if (!this.hasCustomSettings()) {
          return {
            buttonName: globalSettings.button.name,
            cartLabelTextKey: globalSettings.cart.labelText.key,
            cartLabelTextValue: globalSettings.cart.labelText.value,
            messageType: globalSettings.message.type,
            messageValue: globalSettings.message.value,
            badge: globalSettings.badge
          }
        }

        const customSettings = this.preorderVariants[this.variantId].settings;
        const settings = {
          buttonName: customSettings.buttonName || globalSettings.button.name,
          cartLabelTextKey: customSettings.cartLabelTextKey || globalSettings.cart.labelText.key,
          cartLabelTextValue: customSettings.cartLabelTextValue || globalSettings.cart.labelText.value,
          messageType: customSettings.messageType || globalSettings.message.type,
          messageValue: customSettings.messageValue || globalSettings.message.value,
          badge: globalSettings.badge
        }
        return settings;
      }

      hasCustomSettings() {
        if (!this.preorderVariants[this.variantId].settings) {
          return false;
        }
        return this.preorderVariants[this.variantId].settings.type === "CUSTOM";
      }

      isVariantOutOfStock() {
        if (!this.preorderVariants[this.variantId]) {
          return false;
        }

        const variant = this.preorderVariants[this.variantId]
        if (variant.quantity > 0) { return false; }

        if (variant.inventoryPolicy === "DENY") { return true; }
        return false;
      }
    };

    class Shop {
      constructor() { }

      isProductPage(meta) {
        if ("undefined" != typeof meta && "undefined" != typeof meta.product) { return true; }

        return -1 < window.location.href.indexOf("/products/");
      }

      shouldEnable() {
        return this.isCollectionPage() || this.isHomePage() || this.isSearchPage();
      }

      isCollectionPage() {
        return -1 < window.location.href.indexOf("/collections/");
      }

      isSearchPage() {
        return -1 < window.location.href.indexOf("/search?");
      }

      isHomePage() {
        return document.location.pathname === "/";
      }


      initQuickView() {
        this.initQuickViewSettingCache();
        this.createQuickViewButtonListener();
      }

      initQuickViewSettingCache() {
        if ("undefined" != typeof window.ta && "undefined" != typeof window.ta.quickView) {
          return;
        }

        window.ta = {}, window.ta.quickView = {}, window.ta.quickView.selectors = {};
        window.ta.quickView.selectors.button = ".productitem--action-qs, .boost-pfs-quickview-btn, .cc-quick-buy-btn, .button--quick-shop, .sca-qv-button, .quick-view-btn, .bc-quickview-btn-wrapper, .sca-qv-cartbtn, .js-quick-shop-link, .searchit-quick-view-button, .quick-view, .js-quickbuy-button, .quick-product__btn, .product-card-interaction-quickshop, .product-modal, .productitem--action button, a.quickview, .overlay, a.quickview, .has-quick-view .btn .v-b, .shop-now-button, .quick-buy, .quick_shop, a[data-action='show-product'], .trigger-quick-view, .quickview-button, .quick_view, .qview-button, button.btn-addToCart:last, .quick-shop, .fancybox.ajax, .quick-add-button-variants, .product-thumbnail__quickshop-button, .js-quickView-button";
        window.ta.quickView.selectors.modalLoadedMutationClassArray = [
          "quick-shop",
          "sca-fancybox-opened",
          "mfp-ready",
          "bc-quickview-popup-active",
          "remodal-is-opened",
          "searchit-no-scroll",
          "modal--is-active",
          "quickshop-loaded",
          "fancybox-opened",
          "fancybox-is-open",
          "modal-visible",
          "quickview-raised",
          "quick-shop-content",
          "popup",
          "js-drawer-open",
          "modal-open",
          "screen-layer-open",
          "preview",
          "fancybox-lock",
          "slick-slider",
          "quickview-tpl",
          "reveal-modal",
          "quickshop-loaded",
          "is-locked",
          "is-loading",
          "open-in",
          "quickview-image",
          "qview-img",
          "active",
          "load-content",
          "tshopify-popup",
          "loading",
        ];

        window.ta.quickView.selectors.modalLoadedMutationIdArray = ["colorbox"];
        window.ta.quickView.selectors.form = ".product__form:visible, #sca-qv-add-item-form:visible, .shopify-product-form:visible, .bc-modal-wrapper:visible #bc-quickview-cart-form:visible, .product_form:visible, .searchit-quick-view-form-wrapper form:visible, .product-form:visible, .quick-buy__product-form:visible, .product-single__form:visible, form[action='/cart/add']:visible, #AddToCartForm:visible, form.module:visible, #add-to-cart-quickview-form:visible";
        window.ta.quickView.selectors.addToCartButton = ".sca-qv-cartbtn:visible, #addToCart:visible, #bc-quickview-cart-btn:visible, .add_to_cart:visible, #searchit-quick-view-add-to-cart:visible, .product-form__cart-submit:visible, .quickbuy__submit:visible, .add-to-cart:visible, .product-submit:visible, .add:visible, .product-form--atc-button:visible, input.action-button.submit:visible, .addto.cart.sliding-cart:visible, #AddToCart:visible, .product-add:visible, .add-to-cart:visible, .product__submit__add:visible, .product-add-to-cart:visible, #add-to-cart:visible, .product-submit.action-button.product-submit, .product-form__add-button:visible, .add-to-cart-btn:visible, .qview-btn-addtocart:visible, button.btn-addToCart:last, .button--add-to-cart:visible";
        window.ta.quickView.selectors.productImageContainer = ".quick-shop__slideshow:visible, .zoomWrapper:visible, .slides:visible, .bc-quickview-featured-image-wrapper:visible, .flickity-viewport:visible, .searchit-quick-view-image-wrapper:visible, .slick-slider:visible, .product-image-main:visible, .product-main-image:visible, .product-photos .bigimage:visible, .product-gallery:visible, .product-image-zoom:visible, .showcase .container:visible, .responsive-image:visible, .owl-stage:visible, .modal_image:visible, .quickview-featured-image:visible, .product_images:visible, .product-photo-container:visible, .quickview-image:visible";
        window.ta.quickView.selectors.variant = "#sca-qv-variant-options select.single-option-selector, .bc-quickview-single-option-selector, .searchit-option-selector-wrapper select, .qview-variants select, select:visible, .radio-wrapper fieldset, input[type='radio']";
        window.ta.quickView.selectors.quickviewModalContainer = ".theme-modal--quickbuy, .quickview-product .product-quickview:visible, .sca-fancybox-wrap:visible, .mfp-container:visible, .bc-modal-wrapper:visible, .quick-shop:visible, .searchit-modal:visible, #colorbox:visible, .modal--quick-shop:visible, .quickshop:visible, .fancybox-wrap:visible, .fancybox-container:visible, .modal-content:visible, .product-quick-view, section.quick-view, #ShopNowContainer, #ProductScreens, .product.preview, .modal__inner__wrapper:visible, .halo-modal-content:visible, #quickView:visible, .quickshop-content:visible, .modal__inner:visible, .quick-view .content:visible, .qview-product:visible";
        window.ta.quickView.selectors.price = ".sca-qv-price-container .sca-qv-product-price, snize-price, qview-price__current";
        window.ta.quickView.selectors.salePrice = ".sca-qv-price-container .sca-qv-product-price, .sca-qv-price-container .sca-qv-product-compare-price";
      }

      createQuickViewButtonListener() {
        var thisShop = this;
        $(document).on("click", window.ta.quickView.selectors.button, function (target) {
          const handle = thisShop.getProductHandle(target.currentTarget);
          console.log(handle);
          const url = thisShop.getProductPageJsURL(handle);
          var product;
          $.getJSON(url, function (data) {
            product = new Product(data.product.id, data.product.variants);
          }).done(function () {
            // thisShop.cleanupModal();
            new ScriptRunner(product).run(/*isQuickView=*/true);
          }).fail(function () {
            console.log("[Error 1001]: Product could not be fetched.");
          });
        });
      }

      getProductHandle(target) {
        var parts = $(target).attr("href").split('/');
        return parts[parts.length - 1].split('?')[0];
      }

      getProductPageJsURL(handle) {
        return "https://" + window.location.hostname + "/products/" + handle;
      }

      sleep(e) {
        return new Promise(function (t) {
          setTimeout(t, e);
        });
      }

      cleanupModal() {
        $(window.ta.quickView.selectors.quickviewModalContainer).find("#preorder-label").remove();
        $(window.ta.quickView.selectors.quickviewModalContainer).find(".timesact-preorder-description").remove();
      }
    };

    class GlobalSettings {
      constructor(settings) {
        this.button = settings.button;
        this.cart = settings.cart;
        this.message = settings.message;
        if (settings.badge) {
          this.badge = {
            value: settings.badge.value || "",
            product: settings.badge.product || false,
            backgroundColor: settings.badge.backgroundColor || 'linear-gradient(rgb(155, 201, 13) 0%, rgb(121, 167, 10) 100%)',
            fontColor: settings.badge.fontColor || '#FFF'
          }
        } else {
          this.badge = {
            value: "",
            product: false,
            backgroundColor: 'linear-gradient(rgb(155, 201, 13) 0%, rgb(121, 167, 10) 100%)',
            fontColor: '#FFF'
          }
        }
      }
    }

    /* Util classes */
    class ProductUtil {
      extractVariantId(variants, formSelector) {
        var productParams = window.location.search.match(/variant=([0-9]+)/);
        if (productParams != null) return productParams[1];
        const variantIdFromForm =
          "radio" === $(formSelector).find("select[name='id'], input[name='id'], select[name='id[]'], input[name='id[]']").attr("type")
            ? $(formSelector).find("input[name='id']:checked, input[name='id[]']:checked").val()
            : $(formSelector).find("select[name='id'], input[name='id'], select[name='id[]'], input[name='id[]']").val();

        if (variants.some(variant => variant.id.toString() == variantIdFromForm)) {
          return variantIdFromForm;
        }
        // console.log("Variants are different: " + variantIdFromForm + ' ' + variants[0].id);
        return variants[0].id;
      }
    }

    class PreorderButton {
      constructor(buttonSelector, settings) {
        this.buttonSelector = buttonSelector;
        this.addToCartText = settings.addToCartText || $(this.buttonSelector).text();
        this.preorderText = settings.name;
        this.soldOutText = settings.soldOutText;
      }

      showPreorderButton() {
        $(this.buttonSelector).val(this.preorderText);
        $(this.buttonSelector).text(this.preorderText);
        $(this.buttonSelector).prop("disabled", false);
      }

      showAddToCartButton() {
        $(this.buttonSelector).val(this.addToCartText);
        $(this.buttonSelector).text(this.addToCartText);
        $(this.buttonSelector).prop("disabled", false);
      }

      showOutOfStockButton() {
        $(this.buttonSelector).val(this.soldOutText);
        $(this.buttonSelector).text(this.soldOutText);
        $(this.buttonSelector).prop("disabled", true);
      }

      confirmButtonExists() {
        return $(this.buttonSelector).closest("body").length > 0;
      }

      identifyButton(selectors) {
        this.buttonSelector = selectors.formSelector.find(selectors.ids.addToCartButton);
      }

      setPreorderText(text) {
        this.preorderText = text;
      }
    }

    class Preorder {
      constructor(selectors, product, globalSettings) {
        this.selectors = selectors;
        this.product = product;
        this.globalSettings = globalSettings;
        this.button = new PreorderButton(this.selectors.buttonSelector, this.globalSettings.button);
        this.uuid = Math.floor(100000000 + Math.random() * 900000000)
        $(this.selectors.variantSelector).addClass("timesact-variant-picker-" + this.uuid);
      }

      init() {
        this.createWidget();
        new TimesactEventListener().initVariantEventListener(this);
      }

      createWidget() {
        if (this.product.isPreorderEnabledForVariant()) {
          if (this.product.preorderVariants[this.product.variantId].config.status === "NO_STOCK") {
            this.button.showOutOfStockButton();
            $(this.selectors.formSelector).find(".shopify-payment-button").hide();
            return;
          }

          const settings = this.product.getVariantSettings(this.globalSettings);
          this.button.setPreorderText(settings.buttonName);

          if (!this.button.confirmButtonExists()) {
            this.button.identifyButton(this.selectors);
            this.selectors.buttonSelector = $(this.selectors.formSelector).find(this.selectors.ids.addToCartButton);
          }

          this.button.showPreorderButton();
          $(this.selectors.formSelector).find(".shopify-payment-button").hide();
          if (settings.messageValue != "") {
            this.showPreorderMessage(settings.messageType, settings.messageValue);
          }
          this.showPreorderLineItemProperty(settings.cartLabelTextKey, settings.cartLabelTextValue);
          if (settings.badge.product) {
            $('.timesact-badge').append("<div class='timesact-badge-ribbon'><span class='timesact-badge-ribbon-span'>" + settings.badge.value + "</span></div>");
            $('.timesact-badge span.timesact-badge-ribbon-span').css("background", settings.badge.backgroundColor).css("box-shadow", "0 3px 10px -5px rgba(0, 0, 0, 1)");
            $('.timesact-badge-ribbon span').css("color", settings.badge.fontColor);
          }
        }
      }

      resetDefault() {
        if (!this.button.confirmButtonExists()) {
          this.button.identifyButton(this.selectors);
          this.selectors.buttonSelector = $(this.selectors.formSelector).find(this.selectors.ids.addToCartButton);
        }

        if (this.product.isVariantOutOfStock()) {
          this.button.showOutOfStockButton();
          $(this.selectors.formSelector).find(".shopify-payment-button").hide();
        } else {
          this.button.showAddToCartButton();
          $(this.selectors.formSelector).find(".shopify-payment-button").show();
        }
        this.removePreorderLineItemProperty();
        this.removePreorderMessage();
        this.removePreorderBadge();
      }

      showPreorderLineItemProperty(key, value) {
        0 === $(this.selectors.formSelector).find("#preorder-label").length
          ? $(this.selectors.formSelector).append('<input type="hidden" id="preorder-label" name="properties[' + key + ']" value="' + value + '" />')
          : $(this.selectors.formSelector).find("#preorder-label").val(value);
      }

      removePreorderLineItemProperty() {
        $(this.selectors.formSelector).find("#preorder-label").remove();
      }

      removePreorderBadge() {
        $(".timesact-badge-ribbon").remove();
      }

      showPreorderMessage(type, value) {
        if (this.selectors.messageSelector) {
          0 === $(this.selectors.formSelector).find(".timesact-preorder-description").length
            ? type === "BELOW"
              ? $(this.selectors.messageSelector).after("<div class='timesact-preorder-description'>" + value + "</div>")
              : $(this.selectors.messageSelector).before("<div class='timesact-preorder-description'>" + value + "</div>")
            : $(this.selectors.formSelector).find(".timesact-preorder-description").val(value);
          return
        }
        0 === $(this.selectors.formSelector).find(".timesact-preorder-description").length
          ? type === "BELOW"
            ? $(this.selectors.buttonSelector).after("<div class='timesact-preorder-description'>" + value + "</div>")
            : $(this.selectors.buttonSelector).before("<div class='timesact-preorder-description'>" + value + "</div>")
          : $(this.selectors.formSelector).find(".timesact-preorder-description").val(value);
      }

      removePreorderMessage() {
        $(this.selectors.formSelector).find(".timesact-preorder-description").remove();
      }
    }

    class TimesactEventListener {
      initVariantEventListener(preorder) {
        var event = this;
        ($(document).on("change", ".timesact-variant-picker-" + preorder.uuid, function (e) {
          event.variantChangeHandler(preorder);
        }),
          event.setup(function () {
            event.variantChangeHandler(preorder);
          }));
      }

      sleep(e) {
        return new Promise(function (t) {
          setTimeout(t, e);
        });
      }

      variantChangeHandler(preorder) {
        var preorderEntry = preorder;
        this.sleep(250).then(function () {
          var selectedVariantId = window.location.search.replace(/.*variant=(\d+).*/, '$1');
          if (!selectedVariantId) {
            selectedVariantId =
              "radio" === $(preorderEntry.selectors.formSelector).find("select[name='id'], input[name='id'], select[name='id[]'], input[name='id[]']").attr("type")
                ? $(preorderEntry.selectors.formSelector).find("input[name='id']:checked, input[name='id[]']:checked").val()
                : $(preorderEntry.selectors.formSelector).find("select[name='id'], input[name='id'], select[name='id[]'], input[name='id[]']").val();
          }
          preorderEntry.product.setCurrentVariant(selectedVariantId);
          preorderEntry.resetDefault();
          preorderEntry.createWidget();
        });
      }


      track(fn, handler, before) {
        return function r() {
          if (before) return handler.apply(this, arguments), fn.apply(this, arguments);
          var result = fn.apply(this, arguments);
          return handler.apply(this, arguments), result;
        };
      }

      setup(handler) {
        history.pushState = this.track(history.pushState, handler);
        history.replaceState = this.track(history.replaceState, handler);
        window.addEventListener("popstate", handler);
      };
    }

    class Api {
      async getProductPreOrderConfig(productId) {
        try {
          return await $.ajax({
            url: '/apps/timesact/config?productId=' + productId,
            type: 'GET',
            contentType: "application/json; charset=utf-8",
            dataType: "json"
          });
        } catch (err) {
          console.log("[Error 2001]", err);
          return null;
        }
      }

      async getProducts() {
        try {
          return await $.ajax({
            url: '/apps/timesact/products',
            type: 'GET',
            contentType: "application/json; charset=utf-8",
            dataType: "json"
          });
        } catch (err) {
          console.log("[Error 2002]", err);
          return null;
        }
      }
    }

    class Selectors {
      constructor(selectors) {
        this.ids = selectors;
      }

      setNormalSelectors() {
        this.formSelector = $(this.ids.form);
        this.buttonSelector = this.formSelector.find(this.ids.addToCartButton);
        if (this.buttonSelector.length == 0) {
          // In case the Add To Cart button was not identified, we try some generic selectors.
          this.buttonSelector = this.formSelector.find('[type="submit"]:visible:first, [name="add"], .product-submit, .addtocart-button-active, .product-form--add-to-cart, .button--addToCart, .product-form__submit, .add-to-cart, .btn-addtocart, .single_add_to_cart_button, .product-form__cart-submit, .product-form--atc-button, .ProductForm__AddToCart, [type="button"]:visible:first').first();
        }
        this.variantSelector = this.formSelector.find(this.ids.variant);
        if (this.ids.message) {
          this.messageSelector = this.formSelector.find(this.ids.message);
        }
      }

      setQuickViewSelectors() {
        this.formSelector = $(window.ta.quickView.selectors.quickviewModalContainer).find(window.ta.quickView.selectors.form);
        this.buttonSelector = $(window.ta.quickView.selectors.quickviewModalContainer).find(window.ta.quickView.selectors.addToCartButton);
        this.variantSelector = $(window.ta.quickView.selectors.quickviewModalContainer).find(window.ta.quickView.selectors.variant);
        if (this.ids.message) {
          this.messageSelector = this.formSelector.find(this.ids.message);
        }
      }
    }

    /* Main entry point. */
    class ScriptRunner {
      constructor(product) {
        this.product = product;
        this.api = new Api();
        this.productUtil = new ProductUtil();
      }

      async run(isQuickView) {
        const config = await this.api.getProductPreOrderConfig(this.product.id);
        if (!config) { return; }

        this.globalSettings = new GlobalSettings(config.settings)
        this.selectors = new Selectors(config.selectors);
        if (!isQuickView) {
          this.selectors.setNormalSelectors();
        } else {
          this.selectors.setQuickViewSelectors();
        }

        this.product.setCurrentVariant(this.productUtil.extractVariantId(this.product.variants, this.selectors.formSelector));
        this.product.setPreorderVariants(config.product);
        // TODO: create a cache.
        const preorder = new Preorder(this.selectors, this.product, this.globalSettings);
        preorder.init();
      }

      async runCollection() {
        const config = await this.api.getProducts();
        if (!config) { return; }
        if (Object.keys(config.products).length === 0) {
          return;
        }
        this.globalSettings = new GlobalSettings(config.settings);
        this.selectors = new Selectors(config.selectors);
        this.selectors.setNormalSelectors();

        const productForms = $(this.selectors.formSelector);
        for (var form = 0; form < productForms.length; form++) {
          var productId = ($(productForms[form]).attr('id')).split('_')[2];
          if (!config.products[productId]) {
            continue;
          }
          const product = config.products[productId];
          for (let variantId of Object.keys(product.variants)) {
            const buttonSelector = $(productForms[form]).find(this.selectors.buttonSelector);
            if (product.variants[variantId].config.status === "ACTIVE") {
              let buttonName = product.variants[variantId].settings.buttonName || this.globalSettings.button.name
              $(buttonSelector).val(buttonName);
              $(buttonSelector).text(buttonName);
              $(buttonSelector).prop("disabled", false);
              $(productForms[form]).find(".shopify-payment-button").hide();

              let cartValue = product.variants[variantId].settings.cartLabelTextValue || this.globalSettings.cart.labelText.value;
              let cartKey = product.variants[variantId].settings.cartLabelTextKey || this.globalSettings.cart.labelText.key;
              0 === $(productForms[form]).find("#preorder-label").length
                ? $(productForms[form]).append('<input type="hidden" id="preorder-label" name="properties[' + cartKey + ']" value="' + cartValue + '" />')
                : $(productForms[form]).find("#preorder-label").val(cartValue);
            }
            if (product.variants[variantId].config.status === "NO_STOCK") {
              $(buttonSelector).val("Sold out");
              $(buttonSelector).text("Sold out");
              $(buttonSelector).prop("disabled", true);
            }
          }
        }
      }
    }

    $(document).ready(function () {
      var shop = new Shop();
      if (typeof meta !== 'undefined' && shop.isProductPage(meta)) {
        var product;
        $.getJSON(window.location.href, function (data) {
          product = new Product(data.product.id, data.product.variants);
        }).done(function () {
          new ScriptRunner(product).run(/*isQuickView=*/false);
        }).fail(function () {
          console.log("[Error 1001]: Product could not be fetched.");
        });
      }

      if (shop.shouldEnable()) {
        shop.initQuickView();
        // new ScriptRunner(shop, undefined).runCollection();
      }
    });
  };

  /* If jQuery has not yet been loaded or if it has but it's too old for our needs,
  we will load jQuery from the Google CDN, and when it's fully loaded, we will run
  our app's JavaScript. */
  if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 2.1)) {
    loadScript('https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js', function () {
      jQuery191 = jQuery.noConflict(true);
      timesactScript(jQuery191);
    });
  } else {
    timesactScript(jQuery);
  }

})();